import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import { MOBILE_VIDEO_TYPE } from '../../config/consts';
import { IMvLicenceModel } from '../../modules/sites/store';
import messages from './messages';
import { styles } from './styles';

interface ICreditsRequirementProps {
  creditCount: number;
  licenceModelType?: IMvLicenceModel;
}

export function CreditsRequirement({ creditCount = 0, licenceModelType }: ICreditsRequirementProps) {
  return licenceModelType?.type === MOBILE_VIDEO_TYPE.STANDARD ? (
    <Typography sx={{ mt: { sm: '20px', xs: '11px' } }} variant="body2">
      <FormattedMessage
        values={{
          count: creditCount,
          span: (chunks) => (
            <Box component="span" sx={styles.number}>
              {chunks}
            </Box>
          ),
          text: (chunks) => (
            <Box component="span" sx={styles.textColor}>
              {chunks}
            </Box>
          ),
        }}
        {...messages.creditPoolCardRequirementForNextMonth}
      />
    </Typography>
  ) : null;
}
